import { useState } from "react";
import { Home, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { RevenuDirectForm } from "@/components/RevenuDirectForm";
import { api, errMsg, money } from "@/lib/api";
import { typeLocation } from "@/lib/locations";

const Lbl = ({ children }) => <span className="text-[11px] font-mono uppercase tracking-wider text-slate-500 w-36 shrink-0">{children}</span>;

export const LoyerOperation = ({ op, onSaved }) => {
  const [open, setOpen] = useState(false);
  const rd = op.revenu_direct;
  const t = `op-${op.id}-loyer`;
  const retirer = async () => {
    try { await api.delete(`/transactions/${op.id}/revenu-direct`); toast.success("Association au logement retirée"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-1.5 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
      <Lbl>Location</Lbl>
      {rd ? (
        <span className="inline-flex items-center gap-2 rounded-md border border-emerald-200 bg-emerald-50 px-2 py-1 text-xs text-emerald-900" data-testid={t}>
          <Home className="h-3.5 w-3.5" />{typeLocation(rd.type)} · {rd.logement} · {rd.locataire}
          {rd.locataire_id && <span className="font-mono text-[10px] text-emerald-700">mémorisé</span>}
          <button type="button" onClick={retirer} className="text-slate-400 hover:text-red-600" data-testid={`${t}-retirer`}><X className="h-3.5 w-3.5" /></button>
        </span>
      ) : (
        <Button variant="outline" size="sm" className="h-8 w-fit bg-white" onClick={() => setOpen(true)} data-testid={`${t}-associer`}>
          <Home className="h-3.5 w-3.5 mr-1.5" />Associer à un logement
        </Button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="loyer-dialog">
          <DialogHeader>
            <DialogTitle>Associer à un logement</DialogTitle>
            <DialogDescription>{op.date} · {op.description} · {money(op.credit)}</DialogDescription>
          </DialogHeader>
          {open && <RevenuDirectForm depot={op} onDone={() => { setOpen(false); onSaved(); }} />}
        </DialogContent>
      </Dialog>
    </div>
  );
};
